import recovery from "@/store/app/salesforce/recovery/recovery";
import editDomain from "@/store/app/salesforce/editDomain";
import stats from "@/store/app/salesforce/stats";
import seats from "@/store/app/salesforce/seats";
import report from "@/store/app/salesforce/activity-logs/report";
import backedUpItems from "@/store/app/salesforce/activity-logs/backedUpItems";
import backupItems from "@/store/app/salesforce/activity-logs/backupItems";
import backupEventsByDay from "@/store/app/salesforce/activity-logs/backupEventsByDay";
import allEventLogs from "@/store/app/salesforce/activity-logs/allEventLogs";
import backups from "@/store/app/salesforce/backups";
import userReport from "@/store/app/salesforce/userReport";
import settings from "@/store/app/salesforce/settings";
import connectionSettings from "@/store/app/salesforce/settings/connectionSettings";

const defaultState = () => ({})

export default {
  namespaced: true,

  actions: {},

  modules: {
    recovery: recovery,
    editDomain,
    stats,
    seats,
    report,
    allEventLogs,
    backups,
    backedUpItems,
    backupEventsByDay,
    backupItems,
    userReport,
    settings,
    connectionSettings,
  }
}
